<template>
  <div class="ep-wrap" ref="wrapRef">
    <button type="button" class="ep-toggle" @click.stop="togglePicker" title="إضافة إيموجي" aria-label="فتح قائمة الإيموجي">
      😊
    </button>

    <Transition name="ep-pop">
      <div v-if="open" class="ep-popup" @click.stop>
        <emoji-picker @emoji-click="onEmojiClick" class="ep-picker"></emoji-picker>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import 'emoji-picker-element';

const emit = defineEmits(['emoji-select']);
const open = ref(false);
const wrapRef = ref(null);

function togglePicker() {
  open.value = !open.value;
}

function onEmojiClick(event) {
  emit('emoji-select', event.detail.unicode);
  open.value = false;
}

function handleOutsideClick(e) {
  if (open.value && wrapRef.value && !wrapRef.value.contains(e.target)) {
    open.value = false;
  }
}

onMounted(() => document.addEventListener('click', handleOutsideClick));
onBeforeUnmount(() => document.removeEventListener('click', handleOutsideClick));
</script>

<style scoped>
.ep-wrap { position: relative; display: inline-block; margin-bottom: 0.25rem; }

.ep-toggle {
  background: rgba(212,175,55,.08);
  border: 1.5px solid rgba(212,175,55,.15);
  border-radius: 10px;
  padding: .35rem .55rem;
  font-size: 1.2rem; cursor: pointer; line-height: 1;
  transition: all .2s;
}
.ep-toggle:hover {
  background: rgba(212,175,55,.16);
  border-color: rgba(212,175,55,.3);
  transform: scale(1.1);
}

.ep-popup {
  position: absolute;
  bottom: calc(100% + 10px);
  right: 0;
  z-index: 9999;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0,0,0,.22), 0 0 0 1px rgba(212,175,55,.12);
  background: rgba(255,255,255,.98);
  backdrop-filter: blur(20px);
}

/* Transition */
.ep-pop-enter-active, .ep-pop-leave-active { transition: all .2s cubic-bezier(.4,0,.2,1); }
.ep-pop-enter-from, .ep-pop-leave-to { opacity: 0; transform: translateY(8px) scale(.97); }

/* emoji-picker-element skin */
.ep-picker {
  --background: transparent;
  --border-color: rgba(212,175,55,.1);
  --button-hover-background: rgba(212,175,55,.08);
  --category-font-color: #D4AF37;
  --emoji-size: 1.5rem;
  border: none;
}
</style>
